import React from "react";
import { AppProvider } from "@context/AppContext";

// Supports weights 100-900
import "@fontsource-variable/inter";
import "./src/styles/global.css";

export const wrapRootElement = ({ element }) => (
  <AppProvider>{element}</AppProvider>
);
